import timesheetCommentDialogTemplate from './timesheetCommentDialog.html';
import timesheetCommentTemplate from './timesheetComment.html';
//todo: delete unused imports and packages
const { startOfDay, isSameDay, set, addMinutes } = require('date-fns');

angular
   .module('org.saga.timesheetapprovecomment', [
      'org.saga.service',
      'ui.timepicker',
      'ngMaterialDatePicker',
      'isolateForm'
   ])
   .directive('timesheetComment', [
      function () {
         return {
            restrict: 'E',
            template: timesheetCommentTemplate,
            scope: {
               comment: '=',
               newCommentForm: '=',
            },
            controller: [
               '$scope',
               function ($scope) {}
            ]
         };
      }
   ])

   .factory('TimesheetCommentDialog', [
      '$mdDialog',
      '$log',
      function ($mdDialog) {
         return {
            show: function (
               comment,
               callback
            ) {
               function DialogController($scope, $log, $mdDialog) {
                  $scope.comment = comment;

                  $scope.cancel = function () {
                     $mdDialog.cancel();
                  };

                  $scope.ok = function () {
                        $mdDialog.hide($scope.comment);
                  };
               }

               $mdDialog
                  .show({
                     controller: ['$scope', '$log', '$mdDialog', DialogController],
                     template: timesheetCommentDialogTemplate,
                     parent: angular.element(document.body),
                     clickOutsideToClose: false
                  })
                  .then(
                     function (answer) {
                        callback(answer);
                     },
                     function () {
                        // callback is not called
                     }
                  );
            }
         };
      }
   ]);
